import { adminApiRequest } from "../../utils/apiUtils";

export const SearchAPI = {
  searchCafes: (name: string, page: number) => {
    return adminApiRequest
      .get("/pub/find-cafe", {
        params: {
          name,
          page,
          size: 10,
        },
      })
      .then((res) => res);
  },
};
